import React from 'react';
import { IncomeOptionsDTO } from '../../../api/useIncomeQuery';
import { Controller } from 'react-hook-form';
import { Select } from '../../../../../CommonComponents/OPL/Select/Select/Select';

interface Props {
  control: any;
  options: IncomeOptionsDTO;
  fieldName: string;
  onChange(value: number | null): void;
}

export const ManagementStyle = ({ control, options, fieldName, onChange: baseOnChange }: Props) => {
  if (!options.AssetBucketingByManagementStyle) {
    return null;
  }

  const managementStyleOptions = options.ManagementStyles.map(option => ({
    value: option.id,
    label: option.name,
    defaultBucket: option.defaultBucket,
  }));

  return (
    <Controller
      name={fieldName}
      control={control}
      render={({ field: { value, onChange } }) => (
        <Select
          label="Management Style"
          value={managementStyleOptions.find(({ value: v }) => v === value)}
          options={managementStyleOptions}
          onChange={option => {
            onChange(option?.value);

            if (option?.defaultBucket !== undefined) {
              baseOnChange(option?.defaultBucket ?? -1);
            }
          }}
          isPortal
        />
      )}
    />
  );
};
